<template>
  <modal title="Download Report" size="xs" ref="modal">
    <h2 class="text-subtitle1">
      File Format
    </h2>
    <q-radio val="pdf" v-model="format" label="PDF" />
    <q-radio val="docx" v-model="format" label="Word" />
    <q-separator class="q-mt-md" />
    <h2 class="text-subtitle1">Options</h2>
    <q-checkbox
      :model-value="formatOptions.branding"
      label="Add references to Private Footprint"
      @update:modelValue="formatOptions.branding = $event"
    />
    <div class="q-mt-md">
      <q-checkbox
        v-model="formatOptions.index"
        label="Add Social Media Post Index"
      />
    </div>
    <div class="q-mt-md">
      <q-checkbox
        v-model="formatOptions.internalNotes"
        label="Add internal notes"
      />
    </div>
    <div class="q-mt-md">
      <q-checkbox
        v-model="formatOptions.externalComments"
        label="Add external comments"
      />
    </div>
    <div class="q-mt-md">
      <q-checkbox
        v-model="formatOptions.footer"
        label="Add page footer"
      />
    </div>
    <template v-slot:actions>
      <async-btn
        label="Download"
        color="primary"
        :task="task"
        @click="download"
      />
    </template>
  </modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ModalMixin } from '@/mixins';
import { Modal as ModalElement, ReportFormatOptions } from '@/type';
import Modal from '@/components/modal/Modal.vue';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { getTimeZone } from '@/util/time-zone';
import { download } from '../report';

interface Data {
  format: 'pdf'|'docx',
  formatOptions: ReportFormatOptions
  task: Promise<void>|null
}

export default defineComponent({
  emits: ['ok'],
  mixins: [ModalMixin],
  components: {
    Modal,
    AsyncBtn,
  },
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      format: 'pdf',
      formatOptions: {
        branding: false,
        index: false,
        internalNotes: false,
        externalComments: false,
        footer: false,
        timeZone: getTimeZone(),
      },
      task: null,
    };
  },
  methods: {
    download() {
      download(this.reportId, this.format, this.formatOptions).then(() => {
        this.$emit('ok');
        (this.$refs.modal as ModalElement).hide();
        notify({
          message: 'The report is being generated, you will receive an in-app notification when it\'s ready to download.',
          timeout: 60000,
          actions: [
            { label: 'Dismiss', color: 'positive' },
          ],
        });
      });
    },
  },
});
</script>
